
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <div class="row row-replace">
                <div class="col-md-6">
                    <h3 class="card-title">Standard Templates</h3>
                </div>

            </div>


<div class="row">
    <div class="col-md-6">

    </div>
    <div class=" col-md-6 top-corner-items m-b-10">
        <button class="btn btn-primary btn-sm m-r-5" type="button" (click)="openModal('#add_templates')"><i class="fa fa-plus "></i> Add Templates</button>
        <button class="btn btn-primary btn-sm" [routerLink]="['/dashboard']"><i class="fa fa-arrow-left"></i> Back</button>
    </div>
    
</div>

<div class="table-responsive ">
    <table class="table table-striped mb-0" >
        <thead>
            <tr>
                <th>S.No.</th>
                <th>Template Name</th>
                <th>Download Template</th>
            </tr>
        </thead>
        <tbody>
           <tr>
               <td>1</td>
               <td>	Followup Tool</td>
               <td><a href=""> Download Template</a></td>
           </tr>
           <tr>
            <td>2</td>
            <td>GR Audit Tracker</td>
            <td><a href=""> Download Template</a></td>
        </tr>
        <tr>
            <td>3</td>
            <td>GR Site Data Sheet & Score Tracker</td>
            <td><a href=""> Download Template</a></td>
        </tr>
        <tr>
            <td>4</td>
            <td>How to user Site Visit Planner</td>
            <td><a href=""> Download Template</a></td>
        </tr>
        <tr>
            <td>5</td>
            <td>HR Metrics</td>
            <td><a href=""> Download Template</a></td>
        </tr>
        </tbody>
    </table>
</div>

</div>
</div>
</div>

<div id="add_templates" class="modal  custom-modal fade" data-backdrop="static"  role="dialog">
    <div class="modal-dialog   modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="zero_country_form_title"> Add Template</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClosePolicy()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="addTemplateForm" (ngSubmit)="onSubmitTemplate()">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="pol_name">Policy Name<span class="text-danger">*</span></label>
                                <input id="pol_name" type="text" class="form-control"  formControlName="pol_name" placeholder="Policy Name">
                                <div *ngIf="submittedTemplate && policyErrorMsg.pol_name.errors" class="form-error">
                                    <div *ngIf="policyErrorMsg.pol_name.errors.required">Role Name is required !</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="brfurl">Brief Intro<span class="text-danger">*</span></label>
                                <input id="brfurl" type="text" class="form-control"  formControlName="briefurl" placeholder="Brief Intro">
                                <div *ngIf="submittedTemplate && policyErrorMsg.briefurl.errors" class="form-error">
                                    <div *ngIf="policyErrorMsg.briefurl.errors.required">Brief Intro is required !</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="efftv_date">Effective Date<span class="text-danger">*</span></label>
                                <input id="efftv_date" type="date" class="form-control"  formControlName="effct_date">
                                <div *ngIf="submittedTemplate && policyErrorMsg.effct_date.errors" class="form-error">
                                    <div *ngIf="policyErrorMsg.effct_date.errors.required">Effective Date is required !</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="upld_pol">Upload Policy<span class="text-danger">*</span></label>
                                <input id="upld_pol" type="file" class="form-control"  formControlName="upld_pol">
                                <div *ngIf="submittedTemplate && policyErrorMsg.upld_pol.errors" class="form-error">
                                    <div *ngIf="policyErrorMsg.upld_pol.errors.required">Image is required !</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary btn-sm " [disabled]="loading"><span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span><i class="fa fa-save"></i> SAVE</button>
                    <button type="button" class="btn btn-danger btn-sm"  data-dismiss="modal" (click)="onClosePolicy()">Close</button>
                </div>
            </form>
        </div>
     </div>
  </div>